// extracted by mini-css-extract-plugin
export var html_body = "articleTemplate-module--html_body--7efaa";
export var out_div = "articleTemplate-module--out_div--f6d69";